module.exports = __webpack_public_path__ + "static/musa-stamp-a3c85edf93afaac0fc95c3b6f68918d0.png";